module.exports = __webpack_public_path__ + "ae5f061bb4b703408f16d424da61c4c7.webp";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/LynksExport/assets/Sec-1/amazon_logo.webp
// module id = ./app/containers/StaticPage/LynksExport/assets/Sec-1/amazon_logo.webp
// module chunks = 40